<template>
  <div class="m-scoreShop-point-record">
    <el-form class="search" ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="会员手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入会员手机号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onExport" :loading="exportLoading">导出</el-button>
        </el-col>
      </el-row>
    </el-form>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #amount="{ row }">{{ row.amount ? row.amount+'元':'0元'}}+{{ row.point ? row.point+'积分':'0积分'  }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #grantTime="{ row }">{{ row.grantTime ? $moment(row.grantTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #status="{ row }">{{ statusMap[row.status] }}</template>
      <template #operation="{ scope }">
        <el-button v-if="scope.row.status == 'PaymentSuccess'" type="text" @click="onUnPaid(scope.row, scope.$index)">退款</el-button>
      </template>
    </Table>

    <Dialog :dialogShow="dialogShow" title="退款" @maskClick="maskClick">
      <template>
        <el-form class="refundForm" label-position="right" label-width="100px">
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="可退款金额">
                <span class="desc-refund">{{ row.amount ? row.amount:0 }}元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="可退款积分">
                <span class="desc-refund">{{ row.point ? row.point:0}}积分</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="btn-row">
            <el-button class="login-btn" type="default" @click="maskClick">
              取消
            </el-button>
            <el-button type="primary" @click="confirm" :loading="refundLoading">
              确认
            </el-button>
          </el-row>
        </el-form>
      </template>
    </Dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getUserPhone } from '@/api/common'
import { api_getPointMallRecordList,api_getRefund,api_getRefundPoint,api_getExport} from '@/api/scoreShop'
import aes from '@/common/aes.js'
import Table from "@/components/Table/index";
import { downFile } from "@/utils";

import Dialog from '@/components/Dialog/index';
export default {
  name: "mScoreShopPointRecord",
  components: {
    AuthButton,
    Table,
    Dialog
  },
  data() {
    return {
      form: {},
      exportLoading: false,
      tableKey: false,
      tableThData: [
        { prop: "name", label: "商品名称", minWidth: "180", },
        { prop: "amount", label: "支付金额", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "grantTime", label: "兑换时间", minWidth: "180", },
        { prop: "status", label: "兑换状态", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
      dialogShow: false,
      refundLoading: false,
      row: {},
      statusMap: {
        'PaymentSuccess': '已支付',
        'Used': '已核销',
        'Doing': '待支付',
        'Refund': '已退款',
        'Canceled':'已取消',
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        skuId: this.$route.query.id,
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      try {
        const data = await api_getPointMallRecordList(params)
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    onSearch() {
      this.offset = 0
      this.getList()
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show
      } else {
        const {phone} = await api_getUserPhone({id: row.userId})
        this.tableTrData[index].phone_show = aes.decrypt(phone)
      }
      this.tableKey = !this.tableKey
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        skuId: this.$route.query.id,
        ...this.form,
      }
      let res = await api_getExport(params)
      downFile(res)
      this.exportLoading = false
    },

    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    },

    //退款
    onUnPaid(row, index) {
      this.dialogShow = true
      this.row = row
    },

    confirm() {
      this.$baseConfirm(
        '退款为敏感操作，请再次核对是否操作退款？',
        {
          title: '温馨提示',
          type: 'warning',
          cancelButtonText: '取消退款',
          confirmButtonText: '确认退款',
        },
        async () => {
          this.confirmOk()
        }
      )
    },

    async confirmOk() {
      this.refundLoading = true
      try {
        
        this.row.amount ?  await api_getRefund({ payId: this.row.paymentOrderId, amount: this.row.amount, bizId: this.row.bizId }) : await api_getRefundPoint({ skuOrderId: this.row.id, bizId: this.row.bizId })
        this.$baseMessage('退款成功', 'success')
        this.refundLoading = false
        this.maskClick()
        this.getList()
      } catch (error) {
        this.refundLoading = false
      }
    },
    maskClick() {
      this.row = {}
      this.dialogShow = false
    },
  },
};
</script>

<style lang="scss" scoped>
.m-scoreShop-point-record {
  padding: 0 20px;
  box-sizing: border-box;

  .search {
    margin-top: 20px;
  }
  .el-input,
  .el-textarea,
  .el-select,
  .el-date-editor,
  .el-cascader {
    width: 350px;
  }
  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .table-box {
    margin-top: 0px !important;
  }
  .refundForm {
  margin-top: 30px;
  padding-right: 20px;
  box-sizing: border-box;

  .desc-refund {
    font-size: 16px;
    font-weight: 600;
    color: #FF6969;
  }

  .btn-row {
    padding-top: 20px;
    float: right;
    overflow: hidden;
    box-sizing: border-box;

    .el-button+.el-button {
      margin-left: 20px;
    }

    button {
      border: 0;
      width: 110px;
      height: 34px;
      padding: 0;
      line-height: 34px;
      text-align: center;
      font-size: 16px;
    }
  }
}
}
</style>
